import { AppLocalStorage, AppLocalStorageItems } from "../../helpers/localStorageHelper";
import { AppToast } from "../../lib/toast";
// import { getConfiguredLabel } from "../../common/commonHelper";
import { AppRoutes } from "../../routingInfo/routes";
import { setUserAuth } from "../../store/auth/authSlice";
import { getGaiConfig } from "../../store/gai/gaiSlice";
import { initTenantList, setCurrentTenant } from "../../store/tenant/tenantSlice";
// import { HeaderMenu, invalidCredential } from '../../common/labelConstants';

// export function handleLoginResponse(res, navigate, dispatch, refreshCaptcha,form) {






//     if (res) {
//         if (res.status === 200) {
//             dispatch(setUserAuth(res.data))
//             dispatch(initTenantList())
//             dispatch(getGaiConfig())
//             dispatch(setCurrentTenant(res.data?.tenant))
//             const isUserDocumentsExists = res.data.userDocumentsExists
//             const redirectUrl = AppLocalStorage.getStorageItem(AppLocalStorageItems.RedirectUrl) || '/'
//             AppLocalStorage.removeStorageItem(AppLocalStorageItems.RedirectUrl);

//             if (isUserDocumentsExists && (redirectUrl === undefined || redirectUrl === "undefined" || redirectUrl === "/")) {
//                 navigate(AppRoutes.documents, { replace: true, state: undefined })
//             }
//             else
//                 navigate(redirectUrl, { replace: true, state: undefined })
//         }
//         else if (res.status === 400) {
//             AppToast.Toast.error({ title: 'No such username or password' })
//             refreshCaptcha();
//             form.setValue('captcha', '');
//             // AppToast.Toast.error({ title: getConfiguredLabel(mainSection,invalidCredential)})
//             navigate(AppRoutes.signIn, { replace: true, })
//         }
//         else if (res.status === 401) {
//             AppToast.Toast.error({ title: 'Error', message: "Unauthorized access." })
//             navigate(AppRoutes.signIn, { replace: true, state: { unAuthorized: true } })
//         }
//         else if (res.status === 403) {
//             navigate(AppRoutes.signIn, { replace: true, state: { noPermission: true } })
//         }
//         else navigate(AppRoutes.signIn, { replace: true, })
//     }
//     else navigate(AppRoutes.signIn, { replace: true, })

// }

export function handleLoginResponse(res, navigate, dispatch, refreshCaptcha, form) {

    
    if (typeof res === 'string') {
        let msg = "No such username or password";

        if (!res.includes("cannot be displayed")) {
            msg = res;
        }

         AppToast.Toast.error({ title: 'No such username or password' })
        refreshCaptcha();
        form.setValue('captcha', '');
        navigate(AppRoutes.signIn, { replace: true });
        return;
    }

    if (res) {
        if (res.status === 200) {
            dispatch(setUserAuth(res.data))
            dispatch(initTenantList())
            dispatch(getGaiConfig())
            dispatch(setCurrentTenant(res.data?.tenant))
            const isUserDocumentsExists = res.data.userDocumentsExists
            const redirectUrl = AppLocalStorage.getStorageItem(AppLocalStorageItems.RedirectUrl) || '/'
            AppLocalStorage.removeStorageItem(AppLocalStorageItems.RedirectUrl);

            if (isUserDocumentsExists && (redirectUrl === undefined || redirectUrl === "undefined" || redirectUrl === "/")) {
                navigate(AppRoutes.documents, { replace: true, state: undefined })
            }
            else
                navigate(redirectUrl, { replace: true, state: undefined })
        }
        else if (res.status === 400) {
            AppToast.Toast.error({ title: 'No such username or password' })
            refreshCaptcha();
            form.setValue('captcha', '');
            navigate(AppRoutes.signIn, { replace: true })
        }
        else if (res.status === 401) {
            AppToast.Toast.error({ title: 'Error', message: "Unauthorized access." })
            navigate(AppRoutes.signIn, { replace: true, state: { unAuthorized: true } })
        }
        else if (res.status === 403) {
            navigate(AppRoutes.signIn, { replace: true, state: { noPermission: true } })
        }
        else {
            AppToast.Toast.error({ title:'No such username or password' });
            refreshCaptcha();
            form.setValue('captcha', '');
            navigate(AppRoutes.signIn, { replace: true })
        }
    }
    else {
        AppToast.Toast.error({title: 'No such username or password'});
        refreshCaptcha();
        form.setValue('captcha', '');
        navigate(AppRoutes.signIn, { replace: true })
    }
}